import axios from 'axios';
import { getApiUrl } from '@/helpers/api';

export const useApproveCoachActivityTenant = () => {
  const approveCoachActivityTenant = async (id) => {
    try {
      const url = `${getApiUrl()}/admin/coach-activity-tenant/${id}/approve`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return approveCoachActivityTenant;
};
